// extracted by mini-css-extract-plugin
export default {"alert":"EditModal_alert__fQgo8"};